var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-collapse" },
    [
      _c(
        "el-collapse",
        {
          attrs: { accordion: "" },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.activeNamesList, function (itemF, index) {
          return _c(
            "el-collapse-item",
            {
              key: index,
              staticClass: "uni-collapse-item",
              attrs: { name: itemF.id },
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c("i", { staticClass: "el-icon-arrow-up" }),
                    _c("i", { staticClass: "iconfont icon123 gray-light" }),
                    _c("span", { staticClass: "cell-title" }, [
                      _vm._v(_vm._s(itemF.title)),
                    ]),
                    _vm.activeNames == itemF.id
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#ff6800",
                              "margin-left": "10px",
                            },
                          },
                          [_vm._v("(正在学习)")]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "refresh-box" },
                    [
                      _vm._t("title-right", function () {
                        return [
                          [
                            itemF.courseware
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "online",
                                    attrs: {
                                      href: itemF.courseware,
                                      target: "_blank",
                                    },
                                  },
                                  [_c("em"), _c("span", [_vm._v("课件下载")])]
                                )
                              : _vm._e(),
                          ],
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._t("collapseContent", function () {
                return _vm._l(itemF.node, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "collapse-cell" },
                    [
                      _c("div", { staticClass: "title-box item" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("getStudyStatus")(item.rate))),
                        ]),
                        _c("span", { staticClass: "span tit" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        item.video_duration
                          ? _c("span", { staticClass: "span" }, [
                              _vm._v(
                                " 总时长：" +
                                  _vm._s(item.video_duration_format) +
                                  " 已学习：" +
                                  _vm._s(_vm._f("getStudyPersent")(item.rate)) +
                                  "% "
                              ),
                            ])
                          : _c("span", { staticClass: "span" }, [
                              _vm._v("暂无课程视频，请下载课件学习"),
                            ]),
                      ]),
                      item.course_type !== 3 && item.task_num > 0
                        ? _c("div", { staticClass: "item" }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "100px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("getWorkScore")(item.rate))
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "btn-box" }, [
                        _c(
                          "span",
                          { staticClass: "span" },
                          [
                            item.course_type === 1 &&
                            item.task_num > 0 &&
                            (item.rate ? item.rate.task_status === 0 : true) &&
                            ((_vm.dataObj.is_hours_complete === 1 &&
                              (item.rate
                                ? item.rate.learn_status === 1
                                : false)) ||
                              _vm.dataObj.is_hours_complete === 0)
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass:
                                      "uni-disabled-btn disabled-btn-span",
                                    attrs: { plain: "", icon: "el-icon-edit" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goHomework(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" 做作业 ")]
                                )
                              : item.course_type === 1 &&
                                item.task_num > 0 &&
                                _vm.dataObj.is_hours_complete === 1 &&
                                (item.rate
                                  ? item.rate.learn_status === 0
                                  : true)
                              ? _c("span", [_vm._v("未完成学习")])
                              : item.course_type === 1 && item.task_num === 0
                              ? _c("span", [_vm._v("暂无作业")])
                              : _vm._e(),
                            item.course_type === 2 &&
                            item.practice_num > 0 &&
                            (item.rate ? item.rate.task_status === 0 : true) &&
                            ((_vm.dataObj.is_hours_complete === 1 &&
                              (item.rate
                                ? item.rate.learn_status === 1
                                : false)) ||
                              _vm.dataObj.is_hours_complete === 0)
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass:
                                      "uni-disabled-btn disabled-btn-span",
                                    attrs: { plain: "", icon: "el-icon-edit" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goPractice(item)
                                      },
                                    },
                                  },
                                  [_vm._v("做练习")]
                                )
                              : item.course_type == 2 && item.task_num === 0
                              ? _c("span", [_vm._v("暂无练习")])
                              : _vm._e(),
                            item.video_duration && _vm.isAllowed == 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "uni-link-btn",
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-video-play",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startStudy(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.rate
                                            ? item.rate.last_node > 0
                                              ? "继续学习"
                                              : "开始学习"
                                            : "开始学习"
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                })
              }),
            ],
            2
          )
        }),
        1
      ),
      _c("ComponentDialog1", {
        attrs: {
          icon: "fail",
          title: _vm.dialogTitle,
          visible: _vm.isDialogVisible,
          showCancelBtn: false,
          confirmText: _vm.dialogButtonText,
        },
        on: {
          "update:visible": function ($event) {
            _vm.isDialogVisible = $event
          },
          confirm: function ($event) {
            _vm.isDialogVisible = !_vm.isDialogVisible
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }